import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SelectFilter from './SelectFilter';
import { clearTickets, getTicketsV2 } from '../../../actions';
import { optionsPropTypes } from '../forms/select/SelectPropTypes';

const TicketFilter = ({
  loading,
  tickets,
  isMulti,
  isClearable,
  dispatchGetTickets,
  dispatchClearTickets,
  ...rest
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearTickets();
    },
    [],
  );

  const onInputChange = (inputValue) => {
    const value = inputValue.trim();

    if (!value.length) return;
    const ticket = value.split('-');

    if (ticket.length !== 2) return;

    const [series, correlative] = ticket;

    if (series.length < 2 || correlative.length <= 1) return;

    const query = [`documentSeries:${series}`, `documentCode:${correlative}`];

    dispatchGetTickets({ query });
  };

  return (
    <SelectFilter
      isLoading={loading}
      onInputChange={onInputChange}
      options={tickets}
      isMulti={isMulti}
      isClearable={isClearable}
      {...rest}
    />
  );
};

TicketFilter.propTypes = {
  dispatchGetTickets: PropTypes.func.isRequired,
  dispatchClearTickets: PropTypes.func.isRequired,
  tickets: optionsPropTypes,
  placeholder: PropTypes.string,
  onChangeFilter: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  loading: PropTypes.bool,
  isClearable: PropTypes.bool,
};

TicketFilter.defaultProps = {
  placeholder: 'serie-correlativo...',
  isMulti: false,
  loading: false,
  isClearable: true,
  tickets: [],
};

const mapStateToProps = ({ ReservationUnit }) => ({
  tickets: ReservationUnit.Ticket.getIn(['all', 'content', 'content']).map(
    (ticket) => ({
      value: ticket.id,
      label: `${ticket.documentSeries}-${ticket.documentCode}`,
    }),
  ),
  loading: ReservationUnit.Ticket.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetTickets: getTicketsV2,
  dispatchClearTickets: clearTickets,
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketFilter);
